<template>
  <div class="life3">
    <div>
      龍崎區主要農特產為竹筍及鳳梨。因具有特殊的沙質土壤，所種植生產的竹筍及鳳梨別有特殊風味，尤其是竹林在四季裡都呈現彩色景觀，所以龍崎素有「采竹之鄉」的美名。而龍崎區也是適合觀光休閒旅遊的無煙囪區，富有自然景觀及地理環境資源，如行政院農，業委員會水土保持局成功以生態工法改造成為「牛埔泥岩生態教學園區」示範點、虎形山運動休閒公園、龍崎休閒廣場、龍崎竹炭文化園區、龍船日出日落景觀等，非常適合闔家來此一遊。本區多山多丘陵，且因土質多為泥岩及黃砂土，相當貧瘠，因此，農產並不豐富，僅有綠筍、麻筍及鳳梨的生產堪稱大宗，並因土質與鄰近的關廟區不同，因而竹筍及鳳梨的風味獨特，而近年來鳳梨竹筍產量則有凌駕關廟之勢。
    </div>
    <div>&nbsp;</div>
    <div>
      本區由於竹林遍山野，又具獎勵造林傳統，因此，竹編產業及林業，也是本區農產經營中，相當重要且舉足輕重的項目，同時本區更有達九成以上地區被編為山坡地保育區林地，顯見林業亦是本區主要產業之一，獎勵造林更是區公所等單位相當重視的業務之一。在市政府協助下，龍崎竹炭特產，已享有「黑金」的代名語，多元化的產品如竹炭襪、竹炭麵、竹炭沐浴乳、竹炭洗髮精等等，伴隨者竹炭發展的龍崎竹炭故事館也因此成立。
    </div>
    <div>&nbsp;</div>
    <div>&nbsp;</div>
    <div>
      <img src="~@/assets/images/life-page1-img-1.jpg" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Life3',
  data() {
    return {
      page: this.$route.query.page,
    };
  },
  watch: {
    $route() {
      this.page = this.$route.query.page;
    },
  },
};
</script>

<style scoped>
.life3 img {
  width: 100%;
}
</style>
